<div
  class="automation-alert"
  *ngIf="
    isOpen &&
    (automationStats.enabled.skus > 0 || automationStats.paused.skus > 0)
  "
>
  <!-- Left Icon Section -->
  <div class="icon-container">
    <div class="info-circle">
      <i class="fas fa-info-circle"></i>
    </div>
  </div>

  <!-- Content Section -->
  <div class="content-container">
    <div class="header">
      <div class="header-content-responsive">
        <h3 class="title">Automation Update: </h3>
        <div class="body-text">
          The Engine has automatically
          <ng-container *ngIf="automationStats?.paused.skus > 0">
            <strong>paused&nbsp;</strong>
            <span (click)="onAdsDetailLogs('PAUSE')" class="sku-pill">
              {{ automationStats?.paused.skus }} SKUs ({{
                automationStats?.paused.campaigns
              }}
              Child Campaigns)
            </span>
          </ng-container>
          <span
            *ngIf="
              automationStats?.paused.skus > 0 &&
              automationStats?.enabled.skus > 0
            "
            >&nbsp;and
          </span>
          <ng-container *ngIf="automationStats?.enabled.skus > 0">
            <strong>enabled&nbsp;</strong>
            <span (click)="onAdsDetailLogs('ENABLE')" class="sku-pill">
              {{ automationStats?.enabled.skus }} SKUs ({{
                automationStats?.enabled.campaigns
              }}
              Child Campaigns)
            </span>
          </ng-container>
          <span>&nbsp;based on automation configuration.</span>
        </div>
      </div>
      <button class="close-btn" aria-label="Close" (click)="onClose()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Actions Section -->
    <div class="actions">
      <button *ngIf="automationStats?.paused.skus > 0"
        class="btn btn-sm btn-primary" (click)="onRestock()">
        <i class="fas fa-box pr-2"></i>
        Restock Paused SKUs
      </button>
      <button class="btn btn-sm btn-secondary" (click)="onHistory()">
        <i class="fas fa-history pr-2"></i>
        Open History Logs
      </button>
    </div>
  </div>
</div>
